/** Sheet Weight column is stored in grams. Shiprocket expects kilograms. */

export const DEFAULT_ITEM_WEIGHT_GRAMS = 500;

export const MIN_SHIPROCKET_WEIGHT_KG = 0.5;

export function formatGrams(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  if (Math.abs(n - Math.round(n)) < 0.05) return String(Math.round(n));
  return String(Math.round(n * 10) / 10);
}

export function buildWeightLabel(grams) {
  const g = formatGrams(grams);
  if (!g) return "";
  return `${Number(g).toLocaleString("en-IN")} g`;
}

export function gramsToKg(grams) {
  const n = Number(grams);
  if (!Number.isFinite(n) || n <= 0) return NaN;
  return Math.round((n / 1000) * 100) / 100;
}
